interface applicationCategoryType {
  value: string;
  name: string;
}

export const applicationCategoryList: applicationCategoryType[] = [
  {value: 'lug', name: 'Local Undergraduate'},
  {value: 'ovs', name: 'Overseas Undergraduate'},
  {value: 'lpg', name: 'Local Postgradute(Master/PhD)'},
  {value: 'dip', name: 'Postgradute Diploma in Legal'},
  {value: 'samia_scholars', name: 'Samia Scholarship'},
];
